<template>
  <div class="row">
    <div class="col col-md-10 offset-md-1 text-center">
      <div class="d-flex justify-content-start">

        <Combo
              :itens="$global.sites_filtro_completo()"
              v-model="filtroSite"
              style="max-width:150px;margin-right:10px"
              v-if="retornaSite() !== 'Share' && retornaSite() !== 'Stream1x2' && retornaSite() !== '7live'"
            />

        <Combo
          style="max-width:auto;margin-right:10px"
          :itens="itensEventos"
          v-model="filtroEvento"
          :itemSelecione="true"
        />

        <input
          class="form-control inputPesquisa"
          style="max-width:200px;margin-right:10px"
          type="text"
          placeholder="Email..."
          v-model="filtroUsuario"
          @keyup="keyupFiltroUsuario"
        />

        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          style
          @click="carregarItens()"
        >Filtrar</button>
      </div>

      <hr />

      <div class="rowLista">
        <div class="list-group-item list-group-item-dark text-left">
          <div class="row">
            <div class="col">
              <h5 style="margin-top:9px">Usuário ({{this.itens.length}})</h5>
            </div>
            <div class="col col-md-3 text-center">
              <h5 style="margin-top:9px">Sessões ({{sessoesTotais}})</h5>
            </div>
          </div>
        </div>
        <div
          class="list-group-item list-group-item-action text-left"
          v-for="item in itens"
          :key="item.id"
          :item="item"
        >
          <div class="row">
            <div class="col">
              <h5 style="margin-top:9px">{{ item._id.email }} <small><small>{{ item._id.site }}</small></small></h5>
            </div>
            <div class="col col-md-3 text-center">
              <a data-target="#dialogAcessos"
                 data-toggle="modal"
                 style="cursor:pointer"
                 @click="abrirAcessos(filtroEvento,item._id.email)">
                 <h5 style="margin-top:9px">{{ item.total }}</h5>
              </a>
            </div>
          </div>
        </div>
      </div>

      <ListSessaoViewDetalhes ref="listSessaoViewDetalhes"/>

    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import Combo from "../components/Combo.vue";
import ListSessaoViewDetalhes from "./ListSessaoViewDetalhes.vue";

export default {
  name: "ListSessaoView",
  components: { Combo, ListSessaoViewDetalhes },
  props: { itensLimit: { type: Number, default: 10000 } },
  methods: {
    retornaSite()
    {
      return this.$site;
    },
    abrirAcessos(evento,usuario){

      this.$refs.listSessaoViewDetalhes.carregarItens(evento,usuario);

    },
    selecionarEvento(id)
    {

      this.filtroEvento = id;

    },
    async carregarItens() {
      var filtros = "";
      this.itens = [];

      if (this.filtroEvento !== "") {
        filtros += "?evento=" + this.filtroEvento;

        if (this.filtroUsuario !== "") {
          filtros += "&usuario=" + this.filtroUsuario;
        }


        if(this.filtroSite !== "Todos")
        {
          filtros += "&site=" + this.filtroSite;
        }

        filtros += "&_limit=" + this.itensLimit;

        const response = await api.get("/sessaoView" + filtros);
        api.valid(response.data, this.$router);

        this.itens = response.data.itens;
      }
    },
    async carregarItensEventos() {
      var filtros = "";

      filtros += "?_limit=500";

      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      this.itensEventos = [];

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var evento = response.data.itens[indiceEvento];

        this.itensEventos.push({ id: evento._id, nome: evento.site + " / " + evento.nome });
      }
    },
    keyupFiltroUsuario() {
      clearTimeout(this.timerFiltroUsuario);

      var obj = this;

      this.timerFiltroUsuario = setTimeout(function () {
        obj.carregarItens();
      }, 1000);
    },
    formatDateTime(datetime) {
      if (!datetime) return null;
      if (datetime && datetime != null && datetime != "") {
        var options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          //timeZoneName: "short",
          //timeZone: "UTC"
        };
        datetime = new Date(datetime);
        var portugueseTime = new Intl.DateTimeFormat(
          ["pt-BR", "pt-PT"],
          options
        );
        return portugueseTime.format(datetime);
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.carregarItensEventos();
  },
  computed: {
    sessoesTotais: function () {
      return this.itens.reduce(function (a, b) {
        return a + b.total;
      }, 0);
    },
  },
  data: function () {
    return {
      itens: [],
      itensEventos: [],
      filtroSite:"Todos",
      filtroUsuario: "",
      filtroEvento: "",
      timerFiltroUsuario:null
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
